import React, { createContext, useContext, useEffect, useRef, useState } from "react"
import { useAuth } from "../gui/Login/AuthProvider"
import Dirs, { GDir } from "./Dirs"
import Spinner from "../gui/Loading/Spinner"

export type TRootProviderContext = {
    root:GDir|undefined
}

const RootProviderContext = createContext<TRootProviderContext>({} as any)
export const useRootProvider = () => useContext(RootProviderContext)

export default function RootProvider(props:{children:React.ReactNode}) {
    const [root,setRoot] = useState<GDir|undefined>()
    const {isLoggedIn,ready} = useAuth()
    const mounted = useRef<boolean>(false)

    const onRefresh = async () => {
        try {
            setRoot(await Dirs.i.root)
        }catch(e){
            console.log("failed to query directories", e)
        }
    }

    useEffect(() => {
        Dirs.i.on("cache", onRefresh)
        return () => { Dirs.i.removeListener("cache", onRefresh)}
    }, [])

    useEffect(() => {
        if (mounted.current) Dirs.i.expire()
        else mounted.current = true
    }, [isLoggedIn])

    useEffect(() => {
        ready && onRefresh()
    }, [ready])
    
    return <RootProviderContext.Provider value={{root}}>
        {root ? props.children : <div className="flex1 grid place-center"><Spinner/></div>}
    </RootProviderContext.Provider>
}
